// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","newFund":"cFJX_yroSMTowLuSky8vC","activityText":"_3ShZ4xKVSH4w4TSbBYsU90"};